<template>
  <div class='app-container'>
    <icare-table
      ref='table'
      :title-config='titleConfig'
      :request-fun='requestFun'
      :table-pagination='true'
      :pagination-config='tableParams'
      methods-data='get_fire_user'
      params>
      <div>
        <!--        <span class='left-table'>昵称：</span>-->
        <!--        <el-input v-model='work_group_name' placeholder='请输入昵称' style='width: 200px;'></el-input>-->
        <!--        <span class='left-table'>-->
        <!--          <el-button type='primary' icon='el-icon-search' @click='find'>查找</el-button>-->
        <!--        </span>-->
        <span class='left-table'>
           <el-button type='success' icon='el-icon-circle-plus' @click='showAdd'>增加</el-button>
        </span>
      </div>
    </icare-table>
    <!-- 编辑 -->
    <el-dialog :title='editTip' :visible.sync='editVisible' width='50%' @closed='closeDialog'>
      <el-form label-width='120px' ref='form' :rules='rules' :model='form'>

        <el-row :gutter="20">
          <el-col :span="12">

            <el-form-item label='登录账户' v-if='!isEdit' prop='login_name'>
              <el-input t v-model='form.login_name' placeholder='请输入登录账户' style='width: 100%'></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">

            <el-form-item label='登录密码' v-if='!isEdit' prop='password'>
              <el-input t v-model='form.password' placeholder='请输入登录密码' style='width: 100%'></el-input>
            </el-form-item>

          </el-col>
        </el-row>



        <el-row :gutter="20">
          <el-col :span="12">

            <el-form-item label='用户姓名' prop='name'>
              <el-input t v-model='form.name' placeholder='请输入用户姓名' style='width: 100%'></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">

            <el-form-item label='手机号码' prop='phone'>
              <el-input t v-model='form.phone' placeholder='请输入手机号码' style='width: 100%'></el-input>
            </el-form-item>


          </el-col>
        </el-row>


        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label='所在地经度'>
              <el-input-number v-model='form.longitude' :precision='6' controls-position='right'
                               style='width: 100%;'></el-input-number>
            </el-form-item>

          </el-col>
          <el-col :span="12">


            <el-form-item label='所在地纬度'>
              <el-input-number v-model='form.latitude' :precision='6' controls-position='right'
                               style='width: 100%;'></el-input-number>
            </el-form-item>

          </el-col>
        </el-row>
<!--        <el-form-item label='站点管理'>-->
<!--          <el-input v-model='form.manager_group' controls-position='right'-->
<!--                    style='width: 50%;'>-->
<!--            <el-button slot='append' icon='el-icon-search' @click='selectStation()'></el-button>-->
<!--          </el-input>-->
<!--        </el-form-item>-->

        <div style='margin-left: 30px;margin-top: 20px;'>
          <el-row :gutter='24'>
            <el-col :span='24'>
              <div class='amap-page-container'>
                <br />
                <span style='color: red'> 鼠标点击地图某点，获取您要的经纬度 </span>
                <el-amap
                  vid='amapDemo2'
                  :center='center'
                  :zoom='zoom'
                  class='amap-demo'
                  :events='events'>
                  <el-amap-marker v-for='(marker, index) in markers' :key='marker.index' :position='marker.position'
                                  :icon='marker.icon' :title='marker.title' :events='marker.events'
                                  :visible='marker.visible'
                                  :draggable='marker.draggable' :vid='index'></el-amap-marker>
                </el-amap>
                <div class='toolbar'>
                  <br />
                </div>
              </div>
            </el-col>
          </el-row>
        </div>

      </el-form>
      <div slot='footer' class='dialog-footer'>
        <el-button icon='el-icon-circle-close' @click='closeDialog'>取 消</el-button>
        <el-button type='primary' icon='el-icon-circle-plus-outline' @click='save'>确 定</el-button>
      </div>
    </el-dialog>

    <el-dialog title='设置密码' :visible.sync='dialogPasswordVisible' width='25%'>
      <el-form label-width='60px' :model='passwordData'>
        <el-form-item label='新密码'>
          <el-input t v-model='passwordData.password' placeholder='请输入新密码'></el-input>
        </el-form-item>
      </el-form>
      <div slot='footer' class='dialog-footer'>
        <el-button icon='el-icon-circle-close' @click='dialogPasswordVisible = false'>取 消</el-button>
        <el-button type='primary' icon='el-icon-circle-plus-outline' @click='handlePasswordClick'>确 定</el-button>
      </div>
    </el-dialog>

    <!-- 对话框 -->
    <el-dialog title='站点信息' :visible.sync='stationVisible' width='60%'>
      <div slot='footer' class='dialog-footer'>
        <el-container>

          <el-main style='background: #fff;'>
            <el-table
              ref='devTable'
              :data='tableData' stripe highlight-current-row
              :default-sort="{prop: 'date', order: 'descending'}"
              @selection-change='handleSelectionChange'
             >
              <el-table-column type='selection' width='50'></el-table-column>
              <el-table-column prop='work_group_name' label='站点名称' width='160'></el-table-column>
              <el-table-column prop='province' label='省份' width='160'></el-table-column>
              <el-table-column prop='city' label='市/县' width='160'></el-table-column>
              <el-table-column prop='district' label='区/乡' width='160'></el-table-column>
              <el-table-column prop='street' label='街道' width='160'></el-table-column>
            </el-table>
          </el-main>

          <el-footer align='center' style='align-items: center; display: inherit;'>
            <el-pagination
              background
              @size-change='handleSizeChange'
              @current-change='handleCurrentChange'
              :current-page='pagination.page_no'
              :page-sizes='[28, 30, 40, 50]'
              :page-size='28'
              layout='total, sizes, prev, pager, next'
              :total='pagination.count'
            ></el-pagination>
          </el-footer>

        </el-container>
        <el-button icon='el-icon-circle-close' @click='stationVisible=false'>取 消</el-button>
        <el-button type='primary' icon='el-icon-circle-plus-outline' @click='select'>确 定</el-button>
      </div>
    </el-dialog>


  </div>
</template>

<script>
import { gateway } from '@/api/admin.js'

export default {
  data() {
    let self = this
    return {
      loading: false,
      tableParams: {
        // id: null
      },
      //编辑框信息（密码）
      dialogPasswordVisible: false,
      passwordData: {
        password: ''
      },
      //站点框信息
      stationVisible: false,
      tableData: [],
      pagination: {
        page_size: 28, //页面数据条数
        page_no: 1, //页号
        count: 30
      },
      selectionData:[],
      //编辑框信息
      editTip: '',
      editVisible: false,
      isEdit: false,

      titleConfig: [
        {
          field: 'id',
          title: '流水号',
          visible: false
        },
        {
          field: 'name',
          title: '用户姓名',
          visible: true
        },
        {
          field: 'login_name',
          title: '登录账号',
          visible: true
        },
        // {
        //   field: 'password',
        //   title: '登录密码',
        //   visible: true
        // },
        {
          field: 'phone',
          title: '手机号码',
          visible: true
        },
        {
          field: 'longitude',
          title: '所在地经度',
          visible: true
        },
        {
          field: 'latitude',
          title: '所在地纬度',
          visible: true
        },
        {
          field: 'login_time',
          title: '登录时间',
          visible: true
        },
        {
          field: 'create_time',
          title: '创建时间',
          visible: true
        },
        {
          title: '操作',
          width: 60,
          align: 'right',
          option: true,
          children: [
            {
              title: '编辑',
              color: '#67C23A',
              icon: 'el-icon-edit-outline',
              fuc: this.showEdit
            },
            {
              title: '绑定',
              color: '#409EFF',
              icon: 'el-icon-tickets',
              fuc: this.showBing
            },
            {
              title: '改密',
              color: '#E6A23C',
              icon: 'el-icon-key',
              fuc: this.handleSettingClick
            },
            {
              title: '删除',
              icon: 'el-icon-delete',
              color: '#F56C6C',
              fuc: this.delete
            }
          ]
        }
      ],
      rules: {
        login_name: [
          { required: true, message: '请输入登录账户', trigger: 'blur' },
          { max: 20, message: '输入的文字过长，长度应在 20 个字符内', trigger: 'blur' }
        ],
        phone: [
          { required: true, message: '请输入手机号码', trigger: 'blur' },
          { max: 11, message: '输入的文字过长，长度应在 11 个字符内', trigger: 'blur' }
        ]
      },
      form: {
        id: ''
      },
      formLabelWidth: '100px',
      dialogType: 0,


      // 点击显示的标记默认的定位
      markers: [/* {
        position: [121.59996, 31.197646]
      } */],

      zoom: 4,
      center: [109.778671, 32.197646],
      lng: '',
      lat: '',
      //  自动定位到当前位置
      plugin: [{
        timeout: 100, //超过10秒后停止定位，默认：无穷大
        panToLocation: true, //定位成功后将定位到的位置作为地图中心点，默认：true
        zoomToAccuracy: true, //定位成功后调整地图视野范围使定位位置及精度范围视野内可见，默认：f
        pName: 'Geolocation',
        events: {}
      }],

      events: {
        click(e) {
          let { lng, lat } = e.lnglat

          self.lng = lng
          self.lat = lat

          // 这里通过高德 SDK 完成。
          var geocoder = new AMap.Geocoder({
            radius: 1000,
            extensions: 'all'
          })

          self.form.longitude = e.lnglat.lng
          self.form.latitude = e.lnglat.lat

          geocoder.getAddress([e.lnglat.lng, e.lnglat.lat], function(status, result) {
            if (status === 'complete' && result.info === 'OK') {
              if (result && result.regeocode) {
                //在地图显示标注
                self.markers = [{
                  position: [e.lnglat.lng, e.lnglat.lat]
                }]
                self.$nextTick()
              }
            } else {
              alert(result)
            }
          })

          // if(self.address.length > 2){
          //   console.log("-----------------------")
          //   geocoder.getLocation(self.address, function (status, res) {
          //     if (status === 'complete' && res.info === 'OK') {
          //         self.form.longitude=res.geocodes[0].location.lng,
          //         self.form.latitude=res.geocodes[0].location.lat,
          //         //self.address=self.address
          //       self.markers=[{
          //         position: [res.geocodes[0].location.lng,res.geocodes[0].location.lat],
          //       }]
          //     }else{
          //       self.tishi="您输入的地址无法定位到，请先清空地址栏后用鼠标点击选中!";
          //     }
          //   });
          // }else{
          //   console.log("================")
          //   self.form.longitude=lng,
          //     self.form.latitude=lat,
          //     self.markers=[{
          //       position: [lng,lat],
          //     }]
          // }
        }
      }
    }
  },
  computed: {
    requestFun() {
      return gateway
    }
  },
  created() {

  },
  methods: {
    //弹出编辑(新增)对话框
    showAdd() {
      this.isEdit = false
      this.editVisible = true
      this.editTip = '新增信息'
      this.form = Object.assign({})
    },

    //弹出编辑(新增)对话框
    showEdit(row) {
      this.isEdit = true
      this.editTip = '编辑信息'
      this.editVisible = true
      this.form = Object.assign({}, row)
    },

    //弹出编辑(新增)对话框
    showBing(row) {
      this.$router.push({ path: '/fireMgt/fire_binding', query: { fire_user_id: row.id } })
    },

    //关闭编辑对话框
    closeDialog() {
      this.editVisible = false
      this.dialogType = 0
      this.form = {}
    },
    //模糊搜索
    find() {
      // this.tableParams.work_group_name = this.work_group_name
    },
    //删除某条记录
    delete(row) {
      this.$confirm('是否要删除：' + row.name + '？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let str = JSON.stringify({
          id: row.id
        })
        gateway({
          func: 'set_del_fire_user',
          params: str
        }).then(() => {
          this.$refs.table.refresh()
        })
      }).catch(() => {
      })
    },


    handleSettingClick(row) {
      this.dialogPasswordVisible = true
      this.passwordData.id = row.id + ''
      this.passwordData.password = ''
    },

    handlePasswordClick: function() {
      if (this.passwordData.password == '') {
        this.$message.warning('请输入新密码')
        return
      }
      gateway({
        func: 'set_fire_user_pw',
        params: JSON.stringify(this.passwordData)
      }).then(res => {
        if (res.code === 0) {
          this.dialogPasswordVisible = false
          this.$message.success('设置密码成功')
        } else {
          this.$message.warning(res.msg)
        }
      })
    },

    save() {

      let _this = this
      this.$refs.form.validate(valid => {
        if (valid) {

          var params = {}

          if (this.isEdit) {
            params = {
              id: this.form.id + '',
              phone: this.form.phone,
              manager_group: this.form.manager_group,
              longitude: this.form.longitude,
              latitude: this.form.latitude,
              name: this.form.name
            }
          } else {
            _this.form.manager_group = this.form.manager_group,
            params = this.form
          }

          gateway({
            func: _this.isEdit == true ? 'set_fire_user_group' : 'set_create_fire_user',
            params: JSON.stringify(params)
          }).then(res => {
            if (res.code === 0) {
              if (this.isEdit) {
                this.$message.success('编辑成功')
              } else {
                this.$message.success('新增成功')
              }
              this.closeDialog()
              this.$refs.table.refresh()
            } else {
              this.$message.warning(res.msg)
            }
          })

        } else {
          return false
        }
      })
    },

    getStationTableData() {
      // this.loading = true
      let str = JSON.stringify({})
      gateway({
        func: 'get_workgroup',
        page_no: this.pagination.page_no,
        page_size: this.pagination.page_size,
        params: str
      }).then(res => {
        // this.loading = false
        this.tableData = res.result
        this.pagination.count = res.count
      })
    },

    selectStation() {
      let _this = this
      _this.stationVisible = true
      _this.selectionData=[]
      _this.getStationTableData()
    },

    select() {
      let _this=this
      if(_this.selectionData.length>0){
        _this.form.manager_group=_this.selectionData.join(",")
      }
      _this.stationVisible=false
    },

    // 点击跳转页数
    handleCurrentChange(val) {
      this.pagination.page_no = val
      this.getStationTableData()
    },

    handleSizeChange(val) {
      this.pagination.page_size = val
      this.getStationTableData()
    },
    handleSelectionChange(val) {
      this.selectionData=[]
      for (let i = 0; i < val.length; i++) {
        this.selectionData.push(val[i].id)
      }
    },
  }
}
</script>
<style scoped>
.left-table {
  margin-right: 0.5rem;
  color: #8f9398;
  font-size: 18px;
  font-weight: 500;
  margin-left: 10px;
}

.amap-demo {
  height: 400px;
}
</style>
